export enum ExtensionsEnum {
	assertions_sets = 'assertions-sets',
	custom_output_file = 'custom-output-file',
	warehouse = 'warehouse',
	inbound_email = 'inbound-email',
}

export enum CustomOutputFileTypeEnum {
	custom = 'custom',
	generative = 'generative',
}

export enum CustomOutputFileCategoryEnum {
	generative = 'generative',
	custom = 'custom',
}
